import { useQuery } from "@tanstack/react-query";
import { getLieu } from "../api/lieuxApi";
import { queryKeys } from "../lib/queryKeys";

export function useLieuDetail(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.lieux.detail(id ?? ""),
    queryFn: () => getLieu(id as string),
    enabled: Boolean(id),
  });
}
